import React, { Component } from 'react';
import styled from 'styled-components';
import connect from "react-redux/es/connect/connect";

import Theme from './Theme';
import {setTemplate} from "../Actions";
import ThemeList from '../Helpers/ThemeList';

const StyledThemePicker = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
  }
`;



class ThemePicker extends Component {
  componentDidMount() {
    if(!this.props.template) {
      this.props.dispatch(setTemplate ({template: ThemeList[2].template}));
    }
  }
  selectTheme(template) {
    this.props.dispatch(setTemplate ({template}));
  }
  render() {
    return (
      <StyledThemePicker>

        { ThemeList.map(theme => (
          <Theme
            key={theme.template}
            selected={this.props.template === theme.template}
            onClick={() => this.selectTheme(theme.template)}
            theme={theme}
            label={theme.label}
          />
        )) }
      </StyledThemePicker>
    );
  }
}

const mapStateToProps = (state) => ({
  template: state.gift.template,
});

export default connect(mapStateToProps)(ThemePicker);


// WEBPACK FOOTER //
// ./src/Containers/ThemePicker.js